export default "__VITE_ASSET__xes9zYhy__"